import { render, staticRenderFns } from "./LinhaDeContasAPagarResumo.vue?vue&type=template&id=2520513a&scoped=true"
import script from "./LinhaDeContasAPagarResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeContasAPagarResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeContasAPagarResumo.vue?vue&type=style&index=0&id=2520513a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520513a",
  null
  
)

export default component.exports